<template>
  <v-snackbar
    v-model="show"
    :timeout="-1"
    color="warning"
    dark
    multi-line
    top
    right
    class="loan-reminder-snackbar"
  >
    <div class="d-flex flex-column">
      <div class="d-flex align-center mb-2">
        <v-icon left color="white">mdi-clock-alert</v-icon>
        <span class="font-weight-bold">Loan due soon</span>
      </div>
      <div v-for="loan in dueLoans" :key="loan.id" class="mb-2">
        <span>Your loan #{{ loan.id }} of {{ formatAmount(loan.loan_amount) }} FCFA is due on {{ formatDate(loan.due_date) }}.</span>
        <v-btn
          x-small
          color="white"
          text
          class="ml-2"
          :to="`/savings/loans/detail/${loan.id}`"
          @click="show = false"
        >
          View
        </v-btn>
      </div>
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="dismiss">Dismiss</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoanReminderPopup',

  data() {
    return {
      show: false,
      dueLoans: [],
      checkedToday: false,
    }
  },

  computed: {
    currentUserId() {
      return this.$store.state.user_info?.user?.id || this.$store.state.username || 'anonymous'
    }
  },

  mounted() {
    this.checkReminder()
  },

  methods: {
    async checkReminder() {
      // Vérifier si on a déjà montré aujourd'hui
      const lastShown = this.getLastShown()
      const today = new Date().toDateString()
      if (lastShown === today) {
        console.log('Reminder already shown today')
        return
      }

      // Récupérer les prêts actifs
      try {
        const response = await axios.get('/api/v1/savings/get/user/loans/active/')
        const loans = response.data.loans || []
        const now = new Date()
        const fiveDaysFromNow = new Date()
        fiveDaysFromNow.setDate(now.getDate() + 5)

        // Filtrer les prêts du nouveau système (non legacy), non remboursés, échéance dans ≤5 jours
        this.dueLoans = loans.filter(loan => {
          if (loan.is_legacy) return false
          const dueDate = new Date(loan.due_date)
          const isDueSoon = dueDate >= now && dueDate <= fiveDaysFromNow
          const notPaid = (parseFloat(loan.remaining_amount) || 0) > 0
          return isDueSoon && notPaid
        })

        if (this.dueLoans.length > 0) {
          this.show = true
          this.setLastShown(today)
        }
      } catch (error) {
        console.error('Failed to fetch loans for reminder:', error)
      }
    },

    dismiss() {
      this.show = false
      // Ne pas réafficher aujourd'hui (déjà enregistré)
    },

    getLastShown() {
      const key = `loan_reminder_last_shown_${this.currentUserId}`
      return localStorage.getItem(key)
    },

    setLastShown(dateStr) {
      const key = `loan_reminder_last_shown_${this.currentUserId}`
      localStorage.setItem(key, dateStr)
    },

    formatAmount(value) {
      if (!value && value !== 0) return '—'
      return new Intl.NumberFormat('fr-FR').format(value)
    },

    formatDate(dateStr) {
      if (!dateStr) return '—'
      const d = new Date(dateStr)
      return d.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })
    },
  }
}
</script>

<style scoped>
.loan-reminder-snackbar {
  z-index: 9999 !important;
  margin-top: 60px;
}
</style>